export default __webpack_public_path__ + "static/media/Thorneloe University.27431902.png";